type CIMAPIUrlsKey =
  | 'xpmClients'
  | 'xpmClientInfo'
  | 'adeClients'
  | 'adeClientInfo'
  | 'xpmContacts'
  | 'xpmCheckConnection'
  | 'xpmConnect'
  | 'adeCheckConnection'
  | 'adeConnect'
  | 'xpmDisconnect'
  | 'adeDisconnect';

type fuseSignAPIUrlsKey = 'fusesignConnect' | 'fusesignDisconnect';

export const cimAPIUrls: Record<CIMAPIUrlsKey, `/${string}`> = {
  xpmClients: '/xpm/search/clients',
  xpmClientInfo: '/xpm/client/trust-details',
  adeClients: '/app/ade/clients',
  adeClientInfo: '/app/ade/client/trust-details',
  xpmContacts: '/xpm/contacts',
  xpmConnect: '/xpm/connect',
  xpmCheckConnection: '/xpm/check-connection',
  adeCheckConnection: '/app/ade/check-connection',
  adeConnect: '/app/ade/connect',
  xpmDisconnect: '/xpm/disconnect',
  adeDisconnect: '/ade/remove-key',
} as const;

export const fuseSignUrls: Record<fuseSignAPIUrlsKey, string> = {
  fusesignConnect: '/auth/authorize',
  fusesignDisconnect: '/auth/disconnect',
} as const;
